<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <img class="Form__thank_img" src="assets/img/thank.png" alt="ok">
          <p class="Form__tx _ft-cnt">
            メールアドレスの変更が完了しました。
          </p>
          <router-link
            to="/signin"
            class="Btn__blue Form__btn--mt_md Form__btn--mt_sp_sm"
          >
            ログインはこちら
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import store from '@/store'

export default {
  name: 'ChangeMailThanks',
  created() {
    if (store.state.user.isLogin) {
      store.dispatch('user/logout')
    }
  }
}
</script>
